/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicareConditionsServices } from './MedicareConditionsServices';
import {
    MedicareConditionsServicesFromJSON,
    MedicareConditionsServicesFromJSONTyped,
    MedicareConditionsServicesToJSON,
} from './MedicareConditionsServices';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
} from './VisualReference';

/**
 * 
 * @export
 * @interface NtaConditionEvidence
 */
export interface NtaConditionEvidence {
    /**
     * 
     * @type {MedicareConditionsServices}
     * @memberof NtaConditionEvidence
     */
    condition: MedicareConditionsServices;
    /**
     * found=Clear evidence, maybe=Needs confirmation, not_found=Evidence unclear or not present
     * @type {string}
     * @memberof NtaConditionEvidence
     */
    evidence_rating: NtaConditionEvidenceEvidenceRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof NtaConditionEvidence
     */
    rationale: string;
    /**
     * True if the evidence_rating was manually changed from the AI prediction
     * @type {boolean}
     * @memberof NtaConditionEvidence
     */
    is_manually_changed?: boolean;
    /**
     * The original AI-predicted evidence rating before manual change
     * @type {string}
     * @memberof NtaConditionEvidence
     */
    original_evidence_rating?: NtaConditionEvidenceOriginalEvidenceRatingEnum;
    /**
     * The original AI-generated rationale before manual change
     * @type {string}
     * @memberof NtaConditionEvidence
     */
    original_rationale?: string;
    /**
     * 
     * @type {Array<VisualReference>}
     * @memberof NtaConditionEvidence
     */
    visual_references?: Array<VisualReference>;
}


/**
 * @export
 */
export const NtaConditionEvidenceEvidenceRatingEnum = {
    Found: 'found',
    Maybe: 'maybe',
    NotFound: 'not_found'
} as const;
export type NtaConditionEvidenceEvidenceRatingEnum = typeof NtaConditionEvidenceEvidenceRatingEnum[keyof typeof NtaConditionEvidenceEvidenceRatingEnum];

/**
 * @export
 */
export const NtaConditionEvidenceOriginalEvidenceRatingEnum = {
    Found: 'found',
    Maybe: 'maybe',
    NotFound: 'not_found'
} as const;
export type NtaConditionEvidenceOriginalEvidenceRatingEnum = typeof NtaConditionEvidenceOriginalEvidenceRatingEnum[keyof typeof NtaConditionEvidenceOriginalEvidenceRatingEnum];


/**
 * Check if a given object implements the NtaConditionEvidence interface.
 */
export function instanceOfNtaConditionEvidence(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "condition" in value;
    isInstance = isInstance && "evidence_rating" in value;
    isInstance = isInstance && "rationale" in value;

    return isInstance;
}

export function NtaConditionEvidenceFromJSON(json: any): NtaConditionEvidence {
    return NtaConditionEvidenceFromJSONTyped(json, false);
}

export function NtaConditionEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): NtaConditionEvidence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'condition': MedicareConditionsServicesFromJSON(json['condition']),
        'evidence_rating': json['evidence_rating'],
        'rationale': json['rationale'],
        'is_manually_changed': !exists(json, 'is_manually_changed') ? undefined : json['is_manually_changed'],
        'original_evidence_rating': !exists(json, 'original_evidence_rating') ? undefined : json['original_evidence_rating'],
        'original_rationale': !exists(json, 'original_rationale') ? undefined : json['original_rationale'],
        'visual_references': !exists(json, 'visual_references') ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function NtaConditionEvidenceToJSON(value?: NtaConditionEvidence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'condition': MedicareConditionsServicesToJSON(value.condition),
        'evidence_rating': value.evidence_rating,
        'rationale': value.rationale,
        'is_manually_changed': value.is_manually_changed,
        'original_evidence_rating': value.original_evidence_rating,
        'original_rationale': value.original_rationale,
        'visual_references': value.visual_references === undefined ? undefined : ((value.visual_references as Array<any>).map(VisualReferenceToJSON)),
    };
}

